export var AIVoice;
(function (AIVoice) {
    AIVoice["MALE_US"] = "male-us";
    AIVoice["FEMALE_US"] = "female-us";
    AIVoice["FEMALE_UK"] = "female-uk";
})(AIVoice || (AIVoice = {}));
export const AIVoiceConfig = {
    [AIVoice.FEMALE_US]: {
        label: `Female US`,
        voice: `maya`,
    },
    [AIVoice.MALE_US]: {
        label: `Male US`,
        voice: `josh`,
    },
    [AIVoice.FEMALE_UK]: {
        label: `Female UK`,
        voice: `Rosalie - British Female`,
    },
};
export var StatementColumns;
(function (StatementColumns) {
    StatementColumns["Date"] = "date";
    StatementColumns["Activity"] = "activity";
    StatementColumns["Reference"] = "reference";
    StatementColumns["DueDate"] = "duedate";
    StatementColumns["Amount"] = "amount";
    StatementColumns["Payments"] = "payments";
    StatementColumns["OverdueAge"] = "overdue_age";
    StatementColumns["Balance"] = "balance";
})(StatementColumns || (StatementColumns = {}));
export const statementColumnOrder = [
    StatementColumns.Date,
    StatementColumns.Activity,
    StatementColumns.Reference,
    StatementColumns.DueDate,
    StatementColumns.Amount,
    StatementColumns.Payments,
    StatementColumns.OverdueAge,
    StatementColumns.Balance,
];
export var StatementLogoPosition;
(function (StatementLogoPosition) {
    StatementLogoPosition["Right"] = "right";
    StatementLogoPosition["Top"] = "top";
})(StatementLogoPosition || (StatementLogoPosition = {}));
//# sourceMappingURL=settings.js.map